import type { FolderItem, FileItem } from '../../containers/Documents/documentsSlice/types';
import { isGroupFolderOffline, isDocumentOffline } from '../../containers/Documents/helpers';
import type { Group } from '../../containers/GroupsList/groupsSlice/types';
import {
  SInnerFolders,
  SmapItem,
  SCheckBox,
  SCheckBoxContainer,
  SGroupIcon,
  SFolderIcon,
  SFileIcon,
  Name,
  FoldersItemBox,
  InnerFolders,
  InnerItem,
  SubFolderItem,
  SArrowIcon,
  SLine,
} from './DocumentFolders.styles';

type IFolder = {
  type: any;
  dots: string;
  folder: Group;
  fileIcon: string;
  documents: FileItem[];
  isChecked: any[];
  arrowDown: string;
  folderIcon: string;
  arrowRight: string;
  subFolders: FolderItem[]; // TODO: It can also be FileItem[]
  isOpenFolder: boolean;
  isFolderOpen: any;
  handleCheckBox: (
    folder: Group | FolderItem | FileItem,
    checked: boolean,
    groupId?: number,
    subFolderId?: number
  ) => void;
  offlineFileIcon: string;
  groupFolderIcon: string;
  handleOpenFolder: (folder: Group | FolderItem | FileItem) => void;
  offlineFolderIcon: string;
  offlineGroupFolderIcon: string;
};

export function DocumentFolders({
  type,
  folder,
  fileIcon,
  isChecked,
  arrowDown,
  documents,
  arrowRight,
  subFolders,
  folderIcon,
  isOpenFolder,
  isFolderOpen,
  handleCheckBox,
  offlineFileIcon,
  groupFolderIcon,
  handleOpenFolder,
  offlineFolderIcon,
  offlineGroupFolderIcon,
}: IFolder) {
  const activeType = type.createFolders || type.addDocument || type.setOffline || type.editAccess;

  return (
    <SmapItem role="foldersItems">
      <FoldersItemBox
        onClick={activeType ? () => handleOpenFolder(folder) : () => {}}
        role="foldersItemBox"
      >
        <SArrowIcon role="arrowIconContainer">
          {subFolders.length > 0 && activeType && (
            <img alt="arrowIcon" src={isOpenFolder ? arrowDown : arrowRight} role="icon" />
          )}
        </SArrowIcon>
        <SGroupIcon
          alt="folderIcon"
          role="folderIcon"
          src={
            isGroupFolderOffline(folder.id, subFolders, documents)
              ? offlineGroupFolderIcon
              : groupFolderIcon
          }
        />
        <InnerItem role="titleContainer">
          <Name role="title">{folder.name}</Name>
        </InnerItem>
        {activeType && (
          <SCheckBoxContainer
            onClick={() => handleCheckBox(folder, isChecked.includes(folder))}
            role="checkBoxWrapper"
          >
            <SCheckBox isChecked={isChecked.includes(folder)} />
          </SCheckBoxContainer>
        )}
      </FoldersItemBox>
      {isOpenFolder &&
        subFolders.map((subFolder: any, subFolderIndex: number) => {
          const folderFiles = documents.filter(file => file.folderids.includes(subFolder.ID));
          const includeFld = isFolderOpen.folder.includes(subFolder);
          const isFile = Object.keys(subFolder).includes('original_filen_name');
          const isFolder = subFolders.includes(subFolder);

          return (
            <SmapItem key={subFolderIndex} role={`folderItem-${subFolder.Name || subFolder.name}`}>
              <InnerFolders role="innerFolders">
                <SubFolderItem
                  onClick={activeType ? () => handleOpenFolder(subFolder) : () => {}}
                  role="subFolderItem"
                >
                  <SArrowIcon role="arrowIconContainer">
                    {folderFiles.length > 0 && !isFile && (
                      <img alt="arrowIcon" role="icon" src={includeFld ? arrowDown : arrowRight} />
                    )}
                  </SArrowIcon>
                  <SFolderIcon
                    src={
                      isFile
                        ? type.setOffline && isDocumentOffline(subFolder, folder.id, undefined)
                          ? offlineFileIcon
                          : fileIcon
                        : subFolder.Offline
                          ? offlineFolderIcon
                          : folderIcon
                    }
                    alt="folderIcon"
                    role="folderIcon"
                  />
                  <InnerItem role="nameContainer">
                    <Name role="name">
                      {isFile ? subFolder.original_filen_name : subFolder.Name}
                    </Name>
                  </InnerItem>
                  {(type.addDocument
                    ? !isFile
                    : type.setOffline
                      ? true
                      : type.editAccess
                        ? !isFile
                        : type.createFolders && !isFile && !isFolder) && (
                    <SCheckBoxContainer
                      onClick={() =>
                        isFile
                          ? handleCheckBox(
                              subFolder,
                              isChecked.includes(subFolder),
                              folder.id,
                              undefined
                            )
                          : handleCheckBox(subFolder, isChecked.includes(subFolder))
                      }
                      role="checkBoxWrapper"
                    >
                      <SCheckBox isChecked={isChecked.includes(subFolder)} />
                    </SCheckBoxContainer>
                  )}
                </SubFolderItem>
              </InnerFolders>
              {includeFld &&
                folderFiles.map((file: any, fileIndex: number) => {
                  return (
                    <SInnerFolders key={fileIndex} role={`innerFile-${file.original_filen_name}`}>
                      <SubFolderItem role="fileContent">
                        <SFileIcon
                          src={
                            isDocumentOffline(file, folder.id, subFolder.ID)
                              ? offlineFileIcon
                              : fileIcon
                          }
                          alt="fileIcon"
                          role="fileIcon"
                        />
                        <InnerItem role="nameContainer">
                          <Name role="name">{file.original_filen_name}</Name>
                        </InnerItem>
                        {!type.createFolders && !type.addDocument && !type.editAccess && (
                          <SCheckBoxContainer
                            onClick={() =>
                              handleCheckBox(
                                file,
                                isChecked.includes(file),
                                folder.id,
                                subFolder.ID
                              )
                            }
                            role="checkBoxWrapper"
                          >
                            <SCheckBox isChecked={isChecked.includes(file)} />
                          </SCheckBoxContainer>
                        )}
                      </SubFolderItem>
                    </SInnerFolders>
                  );
                })}
            </SmapItem>
          );
        })}
      {isOpenFolder && <SLine role="line"></SLine>}
    </SmapItem>
  );
}
